import req from 'utils/req';

export const fetchTrip = (tripId: string) =>
  req(`${URL_API_HOST}/api/v1/trips/${tripId}`).get();

export const fetchTripToReview = (tripId: string) =>
  req(`${URL_API_HOST}/api/v1/guest/trip/${tripId}`).get();

export function setHostPreferredLanguage(tripId: string, language) {
  return req(
    `${URL_API_HOST}/api/v1/trips/${tripId}/preferred-language/${language}`,
  ).post({});
}

export function updateTripGuests(
  tripId: string,
  numberOfAdults: number,
  numberOfChildren: number,
) {
  return req(`${URL_API_HOST}/api/v1/trips/reservation/${tripId}`).put({
    number_of_adults: numberOfAdults,
    number_of_children: numberOfChildren,
  });
}
